module.exports = (value) => {
  // 判断参数
  const val = isNaN(value) ? 0 : value;
  let theTime = parseInt(val, 10); // 秒
  let theTime1 = 0; // 分
  let theTime2 = 0; // 小时
  if (theTime >= 60) {
    theTime1 = parseInt(theTime / 60, 10);
    theTime = parseInt(theTime % 60, 10);
    if (theTime1 >= 60) {
      theTime2 = parseInt(theTime1 / 60, 10);
      theTime1 = parseInt(theTime1 % 60, 10);
    }
  }
  const time = parseInt(theTime, 10) < 10 ?
    `0${parseInt(theTime, 10)}` : parseInt(theTime, 10);
  const time1 = parseInt(theTime1, 10) < 10 ?
    `0${parseInt(theTime1, 10)}` : parseInt(theTime1, 10);
  const time2 = parseInt(theTime2, 10) < 10 ?
    `0${parseInt(theTime2, 10)}` : parseInt(theTime1, 10);
  const result = `${time2}:${time1}:${time}`;
  return result;
};
